import { useCallback, useEffect, useState } from "react";
import DataTable from "../datatable/DataTable";
import { Link } from "react-router-dom";
import "./admin_blog.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints"; 

const blogDeleteEndpoint = ApiEndpoints.adminBlogs.blogDelete;
const blogListEndpoint = ApiEndpoints.adminBlogs.blogList;
const blogEditPath = "edit-blog";
const tableHeader = ["Title",];
const tbody = ["name",];

export default function BlogListingAdmin() {

  const [data, setData] = useState([]);

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", blogListEndpoint);
      const result = response.blogs;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  }, []);


  useEffect(() => {
    dataFetch();
  }, [dataFetch]);


  const handleDelete = useCallback(
    async (blog_id) => {
      const payload = { blog_id };
      try {
        await ApiRequest("POST", blogDeleteEndpoint, payload);
        dataFetch();
      } catch (error) {
        console.error(error);
      }
    },
    [dataFetch]
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Blogs</h5>
      </div>
      <div className="add-blog-section">
        <Link className="default-btn" to="/admin/add-blog">
          add blog
        </Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={blogEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
